<template>
  <div class="header">
    <a
      :class="['back-button', { mobile: $tvaMq === 'mobile' }]"
      @click="back"
      v-if="getPaint === null"
    >
      <img
        :src="
          `${baseUrl}assets/images/atoms-icons-actions-navigation-chevron-left.svg`
        "
        alt="arrow left"
      /><span>{{
        $ml.get("content")[
          $tvaMq === "mobile" || $tvaMq === "tablet"
            ? "back_button"
            : "back_button_desktop"
        ]
      }}</span></a
    >
    <Navigator />
    <div @click="setPaint(null)" v-if="getPaint !== null" class="close-button">
      <img
        :src="
          `${baseUrl}assets/images/atoms-icons-actions-navigation-close.svg`
        "
        alt="close"
      />
    </div>
    <div class="header-shadow" v-if="getPaint === null"></div>
  </div>
</template>

<script>
import Navigator from "@/components/Navigator.vue";
import { mapActions, mapGetters } from "vuex";
export default {
  name: "home-header",
  computed: {
    ...mapGetters(["getPaint"])
  },
  methods: {
    back() {
      if (this.$route.name === "landing") {
        this.setHomeInLanding(false);
      } else {
        this.$router.push({ name: "landing" });
      }
    },
    ...mapActions(["setPaint", "setHomeInLanding"])
  },
  data() {
    return {
      baseUrl: process.env.BASE_URL
    };
  },
  components: {
    Navigator
  }
};
</script>

<style lang="scss" scoped>
.header {
  position: relative;
  z-index: 1;
  display: flex;
  justify-content: space-between;
  user-select: none;
  .back-button {
    position: absolute;
    top: 17px;
    left: 17px;
    width: 38px;
    height: 35px;
    opacity: 0.9;
    border-radius: 0 22.5px 22.5px 22.5px;
    box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.5);
    background: rgba($primary, 0.9);
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 3px 10px;
    cursor: pointer;
    color: $white !important;
    transition: all 0.2s ease;
    @include h4-mobile-left;
    img {
      display: block;
    }
    span {
      display: none;
    }
    &:hover {
      width: auto;
      background: $primary;
      text-decoration: none !important;
      img {
        margin-left: -1px;
      }
      span {
        margin-left: 3px;
        display: block;
      }
    }
    &.mobile {
      width: auto;
      background: $primary;
      border-radius: 22.5px;
      margin-top: -3px;
      padding: 1px 9px 2px;
      height: 28px;
      img {
        display: none;
      }
      span {
        display: block;
      }
    }
  }
  .close-button {
    position: absolute;
    top: 22.5px;
    right: 24px;
    opacity: 0.5;
    cursor: pointer;
  }
  .header-shadow {
    content: "";
    pointer-events: none;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 135px;
    background: linear-gradient(
      to bottom,
      rgba(21, 15, 10, 0.78),
      rgba(21, 15, 10, 0.37) 66%,
      rgba(21, 15, 10, 0)
    );
    z-index: -1;
  }
}
</style>
